import { render, staticRenderFns } from "./AutoCompleteUserSearch.vue?vue&type=template&id=1c42dd5f&scoped=true&"
import script from "./AutoCompleteUserSearch.vue?vue&type=script&lang=ts&"
export * from "./AutoCompleteUserSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AutoCompleteUserSearch.vue?vue&type=style&index=0&id=1c42dd5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42dd5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VAvatar,VChip,VImg,VListItemAvatar,VListItemContent,VListItemTitle})
